


















































import { Component, Vue } from "vue-property-decorator";
import user from "./user.vue";
@Component({
  components: { user },
})
export default class Home extends Vue {
  public list = ["用户协议", "纠纷处理方式", "隐私协议", "软件许可协议"];
  public active: any = 0;
  public mounted() {
    this.active = this.$route.query.type;
  }
}
